var render = function render(){var _vm=this,_c=_vm._self._c;return _c('intersect',{on:{"enter":_vm.handleEnter,"leave":_vm.handleLeave}},[_vm._t("default",null,null,{ shouldRender: _vm.shouldRender })],2)
}
var staticRenderFns = []

export { render, staticRenderFns }